import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import {inPatientHospitalApi, inPatientProcedureApi, inPatientSchedultApi} from '../../Context/apiData';

export const getAllInpatientProcedure = createAsyncThunk('inPatientSchedule/getInPatientSchedule', async (_, {rejectWithValue}) => {
  try {
    const response = await axios.get(inPatientProcedureApi, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    return response.data.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const createInpatientProcedure = createAsyncThunk('inPatientSchedule/createInpatientProcedure', async (payload, {rejectWithValue}) => {
  try {
    const response = await axios.post(inPatientProcedureApi, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const updateInpatientProcedure = createAsyncThunk('drugInventory/updateInpatientProcedure', async payload => {
  try {
    const response = await axios.put(`${inPatientProcedureApi}${payload.id}/`, payload, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      }
    });

    return response.data.data;
  } catch (error) {
    if (error.response.data.status.code === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

export const deleteInpatientProcedure = createAsyncThunk('inPatientSchedule/deleteInpatientProcedure', async (id, {rejectWithValue}) => {
  try {
    await axios.delete(`${inPatientProcedureApi}${id}/`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    return {id};
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const getAllInpatientHospital = createAsyncThunk('inPatientSchedule/getAllInpatientHospital', async (_, {rejectWithValue}) => {
  try {
    const response = await axios.get(inPatientHospitalApi, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    return response.data.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const createInpatientHospital = createAsyncThunk('inPatientSchedule/createInpatientHospital', async (payload, {rejectWithValue}) => {
  try {
    const response = await axios.post(inPatientHospitalApi, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const updateInpatientHospital = createAsyncThunk('drugInventory/updateInpatientHospital', async ({id, data}) => {
  try {
    const response = await axios.put(`${inPatientHospitalApi}${id}/`, data, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    });

    return response.data.data;
  } catch (error) {
    if (error.response?.data?.status?.code === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.message;
  }
});

export const deleteInpatientHospital = createAsyncThunk('inPatientSchedule/deleteInpatientHospital', async (id, {rejectWithValue}) => {
  try {
    await axios.delete(`${inPatientHospitalApi}${id}/`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    return {id};
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const getAllInpatientSchedule = createAsyncThunk('inPatientSchedule/getAllInpatientSchedule', async (payload, {rejectWithValue}) => {
  try {
    const response = await axios.get(inPatientSchedultApi, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      params: payload
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const createInpatientSchedule = createAsyncThunk('inPatientSchedule/createInpatientSchedule', async (payload, {rejectWithValue}) => {
  try {
    const response = await axios.post(inPatientSchedultApi, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const updateInpatientSchedule = createAsyncThunk('inPatientSchedule/updateInpatientSchedule', async payload => {
  try {
    const response = await axios.put(`${inPatientSchedultApi}${payload.id}/`, payload, {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') + ''
      }
    });

    return response.data;
  } catch (error) {
    console.log(`error -->`, error);
    if (error.response.data.status.code === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return error.response.data || error.message;
  }
});
